import {
  type AutomationQueries,
  defAutomationQueries,
} from '@kizen/query/automation';
import AxiosService from '__services/AxiosService';

const queries: AutomationQueries = defAutomationQueries(AxiosService);

export const automationHistoryQuery: AutomationQueries['automationHistoryQuery'] =
  queries.automationHistoryQuery;

export const automationExecutionVariablesQuery: AutomationQueries['automationExecutionVariablesQuery'] =
  queries.automationExecutionVariablesQuery;

export const automationMessageQuery: AutomationQueries['automationMessageQuery'] =
  queries.automationMessageQuery;

export const automationExecutionInfiniteQuery: AutomationQueries['automationExecutionInfiniteQuery'] =
  queries.automationExecutionInfiniteQuery;

export const automationExecutionByIdQuery: AutomationQueries['automationExecutionByIdQuery'] =
  queries.automationExecutionByIdQuery;

export const runToolsAsOptionsQuery: AutomationQueries['runToolsAsOptionsQuery'] =
  queries.runToolsAsOptionsQuery;
